import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const realityMetaverseExclusiveCampaign2500Matic: Story = {
  id: 'reality-metaverse-exclusive-campaign-2500-matic',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Reality metaverse exclusive campaign 2500 matic',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: "Unlock $MATIC Prizes at Magic Store's Reality Metaverse Campaign",
      description:
        "First 5,000 users win 40¢ $MATIC + share a 500 $MATIC pool! Dive into Magic Store's Reality Metaverse Exclusive Campaign & win big",
      keywords:
        'Metaverse, Magic Store, $MATIC, Win, Exclusive Campaign, Cryptocurrency, 5000 Users, Blockchain, Prizes, Reward, Virtual Reality, Digital Assets, Participate, Limited Offer, Cryptocurrency Rewards',
    },
    config: {
      key: '44fc838ac3685fa43faa40f8d378f7bd0fbd',
      scode: 'MagicSquare',
      ccode: 'z6JrErmcpr',
    },
  },
};
